// store/plugins/authorizationPlugin.js
import { Actions, SubNavigations } from "../../utils/constants";
import { authorizationHelper } from "../helpers/AuthorizationHelper";

const permissionConfig = {
  teams: {
    actions: {
      removeTeam: { type: "team", action: Actions.MANAGE },
      addMember: { type: "team", action: Actions.MANAGE },
      remove: { type: "team", action: Actions.MANAGE },
      changeRole: { type: "team", action: Actions.MANAGE },
      rename: { type: "team", action: Actions.MANAGE },
    },
  },

  pdesigns: {
    actions: {
      create: { type: "team", action: Actions.UPDATE },
      createGrid: { type: "team", action: Actions.UPDATE },
      delete: { type: "team", action: Actions.UPDATE },
      set: { type: "team", action: Actions.UPDATE },
      createProcessFromSAP: { type: "team", action: Actions.UPDATE },
      updateProcessPermissions: { type: "team", action: Actions.UPDATE },
    },
  },

  processes: {
    actions: {
      addProcess: { type: "team", action: Actions.UPDATE },
      addFolder: { type: "team", action: Actions.UPDATE },
      remove: { type: "team", action: Actions.UPDATE },
      removePermanently: { type: "team", action: Actions.UPDATE },
      restore: { type: "team", action: Actions.UPDATE },
      rename: { type: "team", action: Actions.UPDATE },
      renameTeam: { type: "team", action: Actions.UPDATE },
      moveNode: { type: "team", action: Actions.UPDATE },
      moveNodeOneLevel: { type: "team", action: Actions.UPDATE },
      moveProcess: { type: "team", action: Actions.UPDATE },
      syncPermissions: { type: "team", action: Actions.UPDATE },
      addNode: { type: "team", action: Actions.UPDATE },
      resendInvitation: { type: "team", action: Actions.UPDATE },
      renameNode: { type: "team", action: Actions.UPDATE },
      removeNode: { type: "team", action: Actions.UPDATE },
    },
  },

  grids: {
    actions: {
      addFolder: { type: "team", action: Actions.UPDATE },
      addGrid: { type: "team", action: Actions.UPDATE },
      remove: { type: "team", action: Actions.UPDATE },
      removePermanently: { type: "team", action: Actions.UPDATE },
      restore: { type: "team", action: Actions.UPDATE },
      rename: { type: "team", action: Actions.UPDATE },
      renameTeam: { type: "team", action: Actions.UPDATE },
      moveNode: { type: "team", action: Actions.UPDATE },
      moveNodeOneLevel: { type: "team", action: Actions.UPDATE },
      moveGrid: { type: "team", action: Actions.UPDATE },
      syncPermissions: { type: "team", action: Actions.UPDATE },
      addNode: { type: "team", action: Actions.UPDATE },
      resendInvitation: { type: "team", action: Actions.UPDATE },
      renameNode: { type: "team", action: Actions.UPDATE },
      removeNode: { type: "team", action: Actions.UPDATE },
    },
  },
  businesses: {
    actions: {
      addProcess: { type: "team", action: Actions.UPDATE },
      addFolder: { type: "team", action: Actions.UPDATE },
      addGrid: { type: "team", action: Actions.UPDATE },
      remove: { type: "team", action: Actions.UPDATE },
      removePermanently: { type: "team", action: Actions.UPDATE },
      restore: { type: "team", action: Actions.UPDATE },
      rename: { type: "team", action: Actions.UPDATE },
      renameTeam: { type: "team", action: Actions.UPDATE },
      moveNode: { type: "team", action: Actions.UPDATE },
      moveNodeOneLevel: { type: "team", action: Actions.UPDATE },
      moveBusiness: { type: "team", action: Actions.UPDATE },
      // syncPermissions: { type: "team", action: Actions.UPDATE },
      // addNode: { type: "team", action: Actions.UPDATE },
      // resendInvitation: { type: "team", action: Actions.UPDATE },
      // renameNode: { type: "team", action: Actions.UPDATE },
      // removeNode: { type: "team", action: Actions.UPDATE },
    },
  },
  players: {
    actions: {
      addFavorite: { type: "team", action: Actions.UPDATE },
      removeFavorite: { type: "team", action: Actions.UPDATE },
      addPlayer: { type: "team", action: Actions.UPDATE },
      remove: { type: "team", action: Actions.UPDATE },
      removePermanently: { type: "team", action: Actions.UPDATE },
      restore: { type: "team", action: Actions.UPDATE },
      rename: { type: "team", action: Actions.UPDATE },
      moveNode: { type: "team", action: Actions.UPDATE },
      moveNodeOneLevel: { type: "team", action: Actions.UPDATE },
    },
  },
  customFlow: {
    actions: {
      addShape: { type: "design", action: Actions.UPDATE },
      deleteShape: { type: "design", action: Actions.UPDATE },
      updateConnection: { type: "design", action: Actions.UPDATE },
      setSelectedShape: { type: "design", action: Actions.UPDATE },
      setShapeType: { type: "design", action: Actions.UPDATE },
      addConnection: { type: "design", action: Actions.UPDATE },
      setNewArrowActive: { type: "design", action: Actions.UPDATE },
      setNewArrowData: { type: "design", action: Actions.UPDATE },
      resetArrowData: { type: "design", action: Actions.UPDATE },
      moveShape: { type: "design", action: Actions.UPDATE },
      repositionShape: { type: "design", action: Actions.UPDATE },
      setSelection: { type: "design", action: Actions.UPDATE },
      setArrowSelection: { type: "design", action: Actions.UPDATE },
      resetSelection: { type: "design", action: Actions.UPDATE },
      deleteConnection: { type: "design", action: Actions.UPDATE },
      deleteClick: { type: "design", action: Actions.UPDATE },
      setArrowDraggingId: { type: "design", action: Actions.UPDATE },
      setCluePointsId: { type: "design", action: Actions.UPDATE },
      resetCluePointsId: { type: "design", action: Actions.UPDATE },
      toggleVerticalLines: { type: "design", action: Actions.UPDATE },
    },
  },
  pdesign: {
    actions: {
      setDropIndicator: { type: "design", action: Actions.UPDATE },
      resetDropIndicator: { type: "design", action: Actions.UPDATE },
      setEditMode: { type: "design", action: Actions.UPDATE },
    },
  },
  views: {
    actions: {
      changeValue: { type: "design", action: Actions.UPDATE },
      changeValues: { type: "design", action: Actions.UPDATE },
      setShowAddViewDialog: { type: "design", action: Actions.UPDATE },
      setSeriesDialogVisibility: { type: "design", action: Actions.UPDATE },
      addView: { type: "design", action: Actions.UPDATE },
      updateView: { type: "design", action: Actions.UPDATE },
      remove: { type: "design", action: Actions.UPDATE },
      updateViewData: { type: "design", action: Actions.UPDATE },
      changeRowsVisiblity: { type: "design", action: Actions.UPDATE },
      updateCornerData: { type: "design", action: Actions.UPDATE },
      persist: { type: "design", action: Actions.UPDATE },
    },
  },
  sheets: {
    actions: {
      persist: { type: "design", action: Actions.UPDATE },
      addSheet: { type: "design", action: Actions.UPDATE },
      moveToTrash: { type: "design", action: Actions.UPDATE },
      remove: { type: "design", action: Actions.UPDATE },
      restore: { type: "design", action: Actions.UPDATE },
      renameSheet: { type: "design", action: Actions.UPDATE },
      moveNode: { type: "design", action: Actions.UPDATE },
      moveNodeOneLevel: { type: "design", action: Actions.UPDATE },
      moveSheet: { type: "design", action: Actions.UPDATE },
    },
  },
  table: {
    actions: {
      // Not adding Action with read action
      updateSheetData: { type: "design", action: Actions.UPDATE },
      appendRowOrColumnToTable: { type: "design", action: Actions.UPDATE },
      updateTableRangeOnDrag: { type: "design", action: Actions.UPDATE },
      updateTableRange: { type: "design", action: Actions.UPDATE },
      createTable: { type: "design", action: Actions.UPDATE },
      updateTableHeader: { type: "design", action: Actions.UPDATE },
      setAndResetTotalTableRow: { type: "design", action: Actions.UPDATE },
      updateAllTableBelowAddedRows: { type: "design", action: Actions.UPDATE },
      updateAllTableToLeftAddedColumns: { type: "design", action: Actions.UPDATE },
      updateTableDetails: { type: "design", action: Actions.UPDATE },
      persistTableDetails: { type: "design", action: Actions.UPDATE },
      convertToRange: { type: "design", action: Actions.UPDATE },
      deleteTableAndHeaderInRange: { type: "design", action: Actions.UPDATE },
      deleteTableWithData: { type: "design", action: Actions.UPDATE },
      persistNameRangesMap: { type: "design", action: Actions.UPDATE },
      deleteTable: { type: "design", action: Actions.UPDATE },
      deleteTablesInSheet: { type: "design", action: Actions.UPDATE },
      // deleteTablesInDesign: { type: "team", action: Actions.UPDATE }, // it is called in delete design only
      addTableFilter: { type: "design", action: Actions.UPDATE },
      updateTableFilter: { type: "design", action: Actions.UPDATE },
      deleteTableFilter: { type: "design", action: Actions.UPDATE },
      clearFilter: { type: "design", action: Actions.UPDATE },
      setFilterDialogVisible: { type: "design", action: Actions.UPDATE },
      setFilterDialogPosition: { type: "design", action: Actions.UPDATE },
      clearFilterEffect: { type: "design", action: Actions.UPDATE },
      updateHeaderFilter: { type: "design", action: Actions.UPDATE },
      filterRowValues: { type: "design", action: Actions.UPDATE },
      changeRowsVisiblityWithIds: { type: "design", action: Actions.UPDATE },
      sortTable: { type: "design", action: Actions.UPDATE },
      updateTableSorting: { type: "design", action: Actions.UPDATE },
      setShowAddTableDialog: { type: "design", action: Actions.UPDATE },
      setAddNamedRangeVisibility: { type: "design", action: Actions.UPDATE },
      setAddNameSource: { type: "design", action: Actions.UPDATE },
      setEditingNameRange: { type: "design", action: Actions.UPDATE },
      validateAndUpdateHeader: { type: "design", action: Actions.UPDATE },
      addNamedExpression: { type: "design", action: Actions.UPDATE },
      updateNamedExpressionInSheet: { type: "design", action: Actions.UPDATE },
      changeNamedExpression: { type: "design", action: Actions.UPDATE },
      removeNamedExpression: { type: "design", action: Actions.UPDATE },
      createTableNamedRanges: { type: "design", action: Actions.UPDATE },
      updateNamedExpression: { type: "design", action: Actions.UPDATE },
      updateTableNamedRanges: { type: "design", action: Actions.UPDATE },
      deleteTableNamedRanges: { type: "design", action: Actions.UPDATE },
      deleteNamedRanges: { type: "design", action: Actions.UPDATE },
      applyFormulaForAColumn: { type: "design", action: Actions.UPDATE },
      persistNamedExpressions: { type: "design", action: Actions.UPDATE },
    },
  },
  rangeStyle: {
    actions: {
      updateRangeStyle: { type: "design", action: Actions.UPDATE },
      clearStyleFormats: { type: "design", action: Actions.UPDATE },
      addTableStyle: { type: "design", action: Actions.UPDATE },
      removeTableStyle: { type: "design", action: Actions.UPDATE },
      updateTableRangeStyle: { type: "design", action: Actions.UPDATE },
      moveRangeStyle: { type: "design", action: Actions.UPDATE },
      updateFillStyle: { type: "design", action: Actions.UPDATE },
      updateItems: { type: "design", action: Actions.UPDATE },
    },
  },
  cells: {
    actions: {
      updateCustomFlow: { type: "design", action: Actions.UPDATE },
      initEditCell: { type: "design", action: Actions.UPDATE },
      setEditCell: { type: "design", action: Actions.UPDATE },
      addFormulaRange: { type: "design", action: Actions.UPDATE },
      pasteContent: { type: "design", action: Actions.UPDATE },
      copyContent: { type: "design", action: Actions.UPDATE },
      checkTeamValidity: { type: "design", action: Actions.UPDATE },
      fill: { type: "design", action: Actions.UPDATE },
      fillDirection: { type: "design", action: Actions.UPDATE },
      fillSeries: { type: "design", action: Actions.UPDATE },
      resetArrow: { type: "design", action: Actions.UPDATE },
      setArrow: { type: "design", action: Actions.UPDATE },
      addArrow: { type: "design", action: Actions.UPDATE },
      deleteSelectedArrow: { type: "design", action: Actions.UPDATE },
      updateArrow: { type: "design", action: Actions.UPDATE },
      moveRowArrow: { type: "design", action: Actions.UPDATE },
      editCellContent: { type: "design", action: Actions.UPDATE },
      editCellMetaData: { type: "design", action: Actions.UPDATE },
      updateIcon: { type: "design", action: Actions.UPDATE },
      clearFormulaMetaData: { type: "design", action: Actions.UPDATE },
      addActivity: { type: "design", action: Actions.UPDATE },
      moveActivity: { type: "design", action: Actions.UPDATE },
      addRow: { type: "design", action: Actions.UPDATE },
      addColumn: { type: "design", action: Actions.UPDATE },
      removeRows: { type: "design", action: Actions.UPDATE },
      removeColumns: { type: "design", action: Actions.UPDATE },
      editCellContentsByIds: { type: "design", action: Actions.UPDATE },
      addLink: { type: "design", action: Actions.UPDATE },
      updateLink: { type: "design", action: Actions.UPDATE }, // is it depends on team and players
      editLink: { type: "design", action: Actions.UPDATE },
      removeColumnLinks: { type: "design", action: Actions.UPDATE },
      replace: { type: "design", action: Actions.UPDATE },
      persistCellsByIds: { type: "design", action: Actions.UPDATE },
      addPlayer: { type: "design", action: Actions.UPDATE },
      addPostingPlayer: { type: "design", action: Actions.UPDATE },
      movePlayer: { type: "design", action: Actions.UPDATE },
      updateMergedCells: { type: "design", action: Actions.UPDATE },
      removeColumnArrows: { type: "design", action: Actions.UPDATE },
      removeColumnsCell: { type: "design", action: Actions.UPDATE },
      recalculateMergedCells: { type: "design", action: Actions.UPDATE },
      setdropIndicator: { type: "design", action: Actions.UPDATE },
      resetDropIndicator: { type: "design", action: Actions.UPDATE },
      addComment: { type: "design", action: Actions.COMMENT },
      removeComment: { type: "design", action: Actions.COMMENT },
      editCellComment: { type: "design", action: Actions.COMMENT },
      persistCellsComment: { type: "design", action: Actions.COMMENT },
      updateSelectedCells: { type: "design", action: Actions.UPDATE },
      persistSelectedCells: { type: "design", action: Actions.UPDATE },
      deleteSelectedCells: { type: "design", action: Actions.UPDATE },
      mergeAndCenter: { type: "design", action: Actions.UPDATE },
      unmergeCells: { type: "design", action: Actions.UPDATE },
      persistDimensions: { type: "design", action: Actions.UPDATE },
      addRowColumnMap: { type: "design", action: Actions.UPDATE },
      removeRowColumnMap: { type: "design", action: Actions.UPDATE },
      removeNodesFromCellsContent: { type: "design", action: Actions.UPDATE },
      removeCells: { type: "design", action: Actions.UPDATE },
      persistCellsMetaData: { type: "design", action: Actions.UPDATE },
      removeCellsById: { type: "design", action: Actions.UPDATE },
      persistProperty: { type: "design", action: Actions.UPDATE },
      setSelectedArrow: { type: "design", action: Actions.UPDATE },
      resetSelectedArrow: { type: "design", action: Actions.UPDATE },
      selectArrow: { type: "design", action: Actions.UPDATE },
      setRangeDragging: { type: "design", action: Actions.UPDATE },
      setDraggingArrow: { type: "design", action: Actions.UPDATE },
      resetDraggingArrow: { type: "design", action: Actions.UPDATE },
      updateSheetProps: { type: "design", action: Actions.UPDATE },
    },
  },
};

export const authorizationPlugin = (store) => {
  // Intercept the dispatch function to block unauthorized actions
  const originalDispatch = store.dispatch;

  store.dispatch = async function (type, payload) {
    const [moduleName, actionName] = type.split("/");

    const actionConfig = permissionConfig[moduleName]?.actions[actionName];
    if (!actionConfig) {
      // No action config; proceed as normal
      return originalDispatch.call(this, type, payload);
    }

    // Check permissions before allowing action execution
    const isAuthorized = await checkPermission(
      actionConfig.type,
      actionConfig.action,
      payload,
      store.state,
      store.getters,
      store.dispatch
    );

    if (!isAuthorized) {
      // Block the action
      console.error(`Unauthorized action blocked: ${type}`);
      return false; // Return false to block the action execution and prevent the action from being dispatched.
    }

    // Proceed with original dispatch if authorized
    return originalDispatch.call(this, type, payload);
  };
};

async function checkPermission(type, action, payload, state, getters, dispatch) {
  const permissionHelper = authorizationHelper(dispatch, state);

  switch (type) {
    case "design": {
      const designId = selectedDesignId(state);
      return await permissionHelper.checkProcessPermission(designId, action, state.cells.currentPermission);
    }
    case "team": {
      const teamIds = getSelectedTeamId(state, getters);
      for (const teamId of teamIds) {
        const permission = await permissionHelper.checkTeamPermission(teamId, action);
        if (!permission) {
          return false;
        }
      }
      return true;
    }

    default:
      console.warn(`Unknown permission type: ${type}`);
      return false;
  }
}
function selectedDesignId(state) {
  const activeSubNavigation = state.preferences.allPreferences?.activeSubNavigation;

  switch (activeSubNavigation) {
    case SubNavigations.Processes:
      return state.processes?.activeProcess?.itemId;

    case SubNavigations.Grids:
      return state.grids?.activeGrid?.itemId;

    case SubNavigations.Businesses:
      return state.businesses?.activeBusiness?.itemId;

    default:
      return null; // Handle unknown sub-navigation gracefully
  }
}
function getSelectedTeamId(state, getters) {
  const activeSubNavigation = state.preferences.allPreferences?.activeSubNavigation;

  if (!activeSubNavigation) {
    return null; // Return null if activeSubNavigation is not set
  }

  let id = null;

  switch (activeSubNavigation) {
    case SubNavigations.Teams:
      id = state.teams?.activeItem?.id;
      return [getters["teams/teamId"](id) ?? id];

    case SubNavigations.Players: {
      id = state.players?.activePlayer?.id;
      let ids = [];
      if (state.players.selectedTrashItems.length > 0) {
        state.players.selectedTrashItems.forEach((item) => {
          ids.push(getters["players/teamId"](item) ?? item);
        });
        return ids;
      }
      return [getters["players/teamId"](id) ?? id];
    }
    case SubNavigations.Processes: {
      id = state.processes?.activeProcess?.id;
      let ids = [];
      // getting teamId as trash
      if (state.processes.selectedTrashItems.length > 0) {
        for (const item of state.processes.selectedTrashItems) {
          const teamId = getters["processes/teamId"](item) ?? item;
          ids.push(teamId);
        }
        return ids;
      }
      return [getters["processes/teamId"](id) ?? id];
    }
    case SubNavigations.Grids: {
      id = state.grids?.activeGrid?.id;
      let ids = [];
      // getting teamId as trash
      if (state.grids.selectedTrashItems.length > 0) {
        for (const item of state.grids.selectedTrashItems) {
          const teamId = getters["grids/teamId"](item) ?? item;
          ids.push(teamId);
        }
        return ids;
      } else {
        const teamId = getters["grids/teamId"](id) ?? id;
        return [teamId];
      }
    }
    case SubNavigations.Businesses: {
      id = state.businesses?.activeBusiness?.id;
      let ids = [];
      // getting teamId as trash
      if (state.businesses.selectedTrashItems.length > 0) {
        state.businesses.selectedTrashItems.forEach((item) => {
          const teamId = getters["businesses/teamId"](item) ?? item;
          ids.push(teamId);
        });
        return ids;
      }
      return [getters["businesses/teamId"](id) ?? id];
    }

    default:
      return null; // Handle unknown sub-navigation gracefully
  }
}
